import { flatten, values } from 'lodash';
import { getCurrentBrand, brands } from '@stepstone/brand-helpers';
import { useEffect, useState } from 'react';
import { getLang } from './detectLanguage';
export var isFunction = function (entity) { return typeof entity === 'function'; };
export var maxFileNameLength = 100;
var isFileTypeValid = function (file, limits) {
    var _a, _b;
    if (file.type) {
        return limits.supportedMimeTypes.includes(file.type);
    }
    var extension = (_b = (_a = file.name.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : null;
    if (extension)
        return limits.uploadFileType.includes(extension);
    return false;
};
export var validateAttachment = function (file, fileLimits) {
    var result = {};
    if (!isFileTypeValid(file, fileLimits)) {
        result['type'] = 'invalidType';
    }
    if (file.size >= fileLimits.uploadFileSize ||
        file.size <= fileLimits.uploadFileSizeMinimum) {
        result['size'] = 'invalidSize';
    }
    if (file.name.length > maxFileNameLength) {
        result['name'] = 'invalidFileName';
    }
    return result;
};
export var getErrors = function (response, errorLabels) {
    var errorCodes = flatten(values(response.errors));
    return errorCodes.map(function (code) { return errorLabels[code]; }).filter(Boolean);
};
export var formatDate = function (date, options) {
    if (date) {
        return new Date(date).toLocaleDateString(getLang(), options);
    }
    return date;
};
export var delay = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
export var useIsBrandUk = function () {
    var _a = useState(false), isBrandUk = _a[0], setIsBrandUk = _a[1];
    useEffect(function () {
        var brand = getCurrentBrand(window.location.hostname) || brands[0];
        setIsBrandUk(['gb', 'ie'].includes(brand.country));
    }, []);
    return isBrandUk;
};
export var formatBytes = function (num, precision, binaryConversion) {
    if (precision === void 0) { precision = 0; }
    if (binaryConversion === void 0) { binaryConversion = false; }
    var UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];
    if (typeof num != 'number')
        return 'MB';
    if (Math.abs(num) < 1)
        return num + UNITS[0];
    if (num < 0)
        return 0 + UNITS[0];
    if (precision < 0 || precision > 10) {
        console.debug('formatBytes func. Precision must be between 0 and 10. Setting to 0.');
        precision = 0;
    }
    var bytes = binaryConversion ? 1024 : 1000;
    var exponent = Math.floor(Math.log(num) / Math.log(bytes));
    var n = num / Math.pow(bytes, exponent);
    var result = precision ? n.toFixed(precision) : Math.floor(n);
    return '' + result + UNITS[exponent];
};
//# sourceMappingURL=helpers.js.map